import {useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {fetchQueryToolData} from '../Redux/Thunks/queryToolThunks';
import {selectHasQueryColumns} from '../Redux/Selectors/queryToolSelectors';

export const useQueryData = () => {
    const dispatch = useDispatch();

    return useCallback((withCount = true) => {
        dispatch(fetchQueryToolData({withCount}));
    }, [dispatch]);
};

export const useHasColumns = () => useSelector(selectHasQueryColumns);

export const useGetPlaceholderGuid = () => {
    const {newColumns} = useSelector(state => state.queryToolState);

    return newColumns[0]?.data?.guid;
};
